import React, { useCallback, useState } from 'react';

import { MDText } from 'i18n-react';

import { getServiceFeeTiers } from 'Services/privateApis';

import type { ServiceFeeTier, ServiceFeeTiersResponse } from '../../../../server/views/serviceFees/serviceFees.types';
import { usePageRefEvents } from '../../../containers/app/common/Hooks/usePageRefEvents';
import { formatFee, formatPriceRange } from '../helpers/formatTier';
import Texts from '../transactionFees.texts.json';

import styles from './FeesTable.scss';

const LocalT = new MDText(Texts.feesTable);

export const FeesTable = () => {
  const [tiers, setTiers] = useState<ServiceFeeTier[]>([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const onRefTrigger = useCallback(() => {
    if (hasLoaded) {
      return;
    }

    setHasLoaded(true);

    getServiceFeeTiers()
      .then((data: ServiceFeeTiersResponse) => {
        setTiers(data?.tiers ?? []);
      })
      .catch((err) => {
        setTiers([]);
        window?.Sentry?.captureException?.(new Error(err), {
          tags: {
            fetch: 'fees table',
          },
        });
      });
  }, [hasLoaded]);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  return (
    <div ref={(ref) => setRef(ref)} data-testid="fees-table">
      {tiers.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{LocalT.translate('priceLabel')}</th>
              <th>{LocalT.translate('feeLabel')}</th>
            </tr>
          </thead>
          <tbody>
            {tiers.map((tier, index) => (
              <tr key={tier.tier}>
                <td>
                  {formatPriceRange({
                    index,
                    isLast: index === tiers.length - 1,
                    maxPrice: tier.maxPrice,
                    minPrice: tier.minPrice,
                  })}
                </td>
                <td>{formatFee(tier.fee)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
